import { render, staticRenderFns } from "./TimeUFA.vue?vue&type=template&id=2264e7bc&scoped=true"
import script from "./TimeUFA.vue?vue&type=script&lang=js"
export * from "./TimeUFA.vue?vue&type=script&lang=js"
import style0 from "./TimeUFA.vue?vue&type=style&index=0&id=2264e7bc&prod&lang=scss&scoped=true"
import style1 from "./TimeUFA.vue?vue&type=style&index=1&id=2264e7bc&prod&lang=scss"
import style2 from "./TimeUFA.vue?vue&type=style&index=2&id=2264e7bc&prod&lang=scss&scoped=true"
import style3 from "./TimeUFA.vue?vue&type=style&index=3&id=2264e7bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264e7bc",
  null
  
)

export default component.exports